import { PaymentOption } from 'journey/productDetails/typings';

export const constructPaymentOptionsDescription = (
  paymentOption: PaymentOption,
  isBusiness: boolean,
  productPrice: number,
) => {
  const { downPaymentRequired, minimumDownPaymentAmount, priceLength } =
    paymentOption;

  const paymentDescription = paymentOption?.description || null;

  // Don't show anything for SME until IFP fields are properly handled in backend
  if (isBusiness || (productPrice < 1000 && priceLength !== 36)) {
    return '';
  }

  if (productPrice < 1000 && priceLength === 36) {
    return `If you're purchasing over an interest free term, an upfront payment may apply (which will reduce your monthly payments). The exact amount you'll pay will be determined after your credit check has been completed.`;
  }

  if (downPaymentRequired) {
    return `An upfront payment of at least $${minimumDownPaymentAmount} will apply (which will reduce your monthly payments). The exact amount you'll pay will be determined after your credit check has been completed.`;
  }

  return paymentDescription;
};
